import { CommonModule, DatePipe, NgIf, TitleCasePipe } from '@angular/common';
import { Component, OnInit, computed, signal } from '@angular/core';
import { PropertyService } from '../../../_services/properties/property.service';
import { ToastService } from '../../../_services/toast.service';
import { InrShortPipe } from '../../../_pipes/indian-currency.pipe';
import { LoaderService } from '../../../_services/loader.service';
import { AdvisorService } from '../../../_services/advisor/advisor.service';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-requests',
  // Simplified imports: CommonModule already includes NgIf, DatePipe, etc.
  imports: [CommonModule, FormsModule],
  templateUrl: './requests.component.html',
  styleUrl: './requests.component.scss',
  // Ensure InrShortPipe is provided here if it doesn't have {providedIn: 'root'}
  providers: [InrShortPipe],
  standalone: true,
})
export class RequestsComponent implements OnInit {
  isAssignAdvisor = signal(false);
  proRequests = signal<any[]>([]);
  allAdvisors: any[] = [];
  advisorList = signal<any[]>([]);

  // Track the single selected advisor
  selectedAdvisorId = signal<string | null>(null);
  selectedPropReq = signal<any>({});
  isConfirmDisabled = computed(() => this.selectedAdvisorId() === null);

  isRequestModalOpen = signal(false);
  selectedUserRequests = signal<any[]>([]);
  selectedUserName = signal<string>('');

  searchQuery = signal('');
  currentPage = signal(1);
  pageSize = signal(5);
  pages = computed(() => Array.from({ length: this.totalPages() }));

  constructor(
    private readonly _PS: PropertyService,
    private readonly _AS: AdvisorService,
    private readonly _NS: ToastService,
    private readonly inrShortPipe: InrShortPipe,
    private readonly loaderService: LoaderService,
  ) {}

  ngOnInit(): void {
    this.getAllPropertyRequest();
    this.getAllAdvisor();
  }

  // --- Advisor Selection Logic ---

  selectAdvisor(id: string) {
    this.selectedAdvisorId.set(id);
  }

  getAllAdvisor() {
    this.loaderService.show();
    this._AS.advisor().subscribe({
      next: (res: any) => {
        if (res.status) {
          this.allAdvisors = res.data.filter((_:any)=>_.role.id == 'sales_advisor');
          this.advisorList.set(this.allAdvisors);
          // Optional: Set default selection if data exists
          if (res.data.length > 0) {
            // this.selectedAdvisorId.set(res.data[0]._id);
          }
        }
      },
      error: (err) => {
        this.loaderService.hide();
        this._NS.error('Failed to load advisors.');
      },
      complete: () => this.loaderService.hide(),
    });
  }

  onSearch(event: any) {
    const query = event.target.value.toLowerCase();
    const filtered = this.allAdvisors.filter(
      (a: any) =>
        a.name.toLowerCase().includes(query) ||
        a.specialization.toLowerCase().includes(query)
    );
    this.advisorList.set(filtered);
  }

  getAllPropertyRequest() {
    this._PS.getAllPropertyReq().subscribe({
      next: (res: any) => {
        if (res.status) {
          this.proRequests.set(this.groupByUser(res.data));
          console.log('this.proRequests',this.proRequests())
        }
      },
      error: (err) => this._NS.error('Server connection failed'),
    });
  }
 user:any = null
  assignAdvisor(request: any) {
    console.log('request',request)
    this.user = request.user
    this.selectedPropReq.set(request.requests);
    this.isAssignAdvisor.set(true);
  }

  closeModal() {
    this.isAssignAdvisor.set(false);
    this.selectedAdvisorId.set(null);
  }

  formatPropertyNames(requests: any[]): string {
    if (!requests || requests.length === 0) return '';
    return requests.map(req => req.property.name).join(' | ');
  }

  formatPriceDisplay(priceData: any): string {
    if (!priceData) return 'N/A';
    if (Array.isArray(priceData)) {
      if (priceData.length === 0) return 'N/A';
      const values = priceData
        .map((p) => Number(p.price))
        .filter((v) => !isNaN(v));
      if (values.length === 0) return 'N/A';

      const min = Math.min(...values);
      const max = Math.max(...values);
      if (values.length === 1 || min === max) {
        return this.inrShortPipe.transform(min);
      }
      return `${this.inrShortPipe.transform(
        min
      )} - ${this.inrShortPipe.transform(max)}`;
    }
    return this.inrShortPipe.transform(priceData);
  }
  confirmAdvisor() {
    if (!this.user) return
    const currentId = this.selectedAdvisorId();
    const selectedAdvisor = this.advisorList().find((a) => a._id === currentId);
    if (selectedAdvisor) {
      // const payload = {
      //   advisorId: currentId,
      //   name: selectedAdvisor.name,
      //   email: selectedAdvisor.email,
      //   phone: selectedAdvisor.phone,
      //   property: {
      //     ...this.selectedPropReq().property,
      //   },
      // };
      const payload = {
        advisorId: currentId,
        name: selectedAdvisor.name,
        email: selectedAdvisor.email,
        phone: selectedAdvisor.phone,
        specialization: selectedAdvisor.specialization,
        image:selectedAdvisor.advisorImg
      };
       console.log(this.selectedPropReq())
      this.loaderService.show();
      this._AS.assignAdvisor({userId:this.user.userId, assignedAdvisor:payload}).subscribe({
        next: (res) => {
          this.loaderService.hide();
          if (res.success) {
            this._NS.success(
              res.message || `Advisor ${payload.name} assigned successfully!`
            );
            this.closeModal();
          } else {
            this._NS.error(res.message);
          }
        },
        error: (err) => {
          this.loaderService.hide();
          const specificError = Array.isArray(err.details)
            ? err.details[0]
            : err.message;
          this._NS.error(specificError);
          this.closeModal();
        },
      });
    }
  }

  groupByUser(data: any[]) {
    const userMap = new Map<string, { user: any;assignedAdvisor:any, requests: any[] }>();
  
    for (const item of data) {
      const { userId, name, email, phone, property, createdAt, updatedAt, _id, assignedAdvisor } = item;
  
      if (!userMap.has(userId)) {
        userMap.set(userId, {
          user: { userId, name, email, phone },
          assignedAdvisor:assignedAdvisor,
          requests: [],
        });
      }
  
      userMap.get(userId)!.requests.push({
        _id,
        property,
        createdAt,
        updatedAt,
      });
    }
  
    return Array.from(userMap.values());
  }
  private expandedUsers = new Set<string>();

toggleUser(userId: string) {
  if (this.expandedUsers.has(userId)) {
    this.expandedUsers.delete(userId);
  } else {
    this.expandedUsers.add(userId);
  }
}

  isExpanded(userId: string): boolean {
    return this.expandedUsers.has(userId);
  }
  // Total requests count across all groups
  getTotalRequests(): number {
    return this.proRequests().reduce((sum, group) => sum + group.requests.length, 0);
  }

  // Deduplicate BHK types within a property
  getUniqueBhk(prices: any[]): any[] {
    const seen = new Set<string>();
    return prices.filter(p => {
      if (seen.has(p.bhkType)) return false;
      seen.add(p.bhkType);
      return true;
    });
  }

  openRequestModal(group: any) {
    this.selectedUserRequests.set(group.requests);
    this.selectedUserName.set(group.user.name);
    this.isRequestModalOpen.set(true);
  }

  closeRequestModal() {
    this.isRequestModalOpen.set(false);
  }

  filteredRequests = computed(() => {
    const query = this.searchQuery().toLowerCase().trim();

    if (!query) return this.proRequests();

    return this.proRequests().filter(group =>
      group.user.name.toLowerCase().includes(query) ||
      group.user.email.toLowerCase().includes(query) ||
      group.user.phone.includes(query)
    );
  });

  paginatedRequests = computed(() => {
    const start = (this.currentPage() - 1) * this.pageSize();
    return this.filteredRequests().slice(start, start + this.pageSize());
  });
  totalPages = computed(() =>
    Math.ceil(this.filteredRequests().length / this.pageSize())
  );
  goToPage(page: number) {
    if (page < 1 || page > this.totalPages()) return;
    this.currentPage.set(page);
  }
  getRangeEnd(): number {
    return Math.min(
      this.currentPage() * this.pageSize(),
      this.filteredRequests().length
    );
  }
  onTableSearch(event: any) {
    const value = event.target.value || '';
    this.searchQuery.set(value);
    this.currentPage.set(1); // reset pagination on search
  }
}
